window.addEventListener("load", (e) => {
  document.querySelectorAll(".woof_container_inner h4").forEach(function (h) {
    if (h.querySelector("a.woof_front_toggle")) {
      h.style.cursor = "pointer";
      h.addEventListener("click", function (e) {
        h.querySelector("a.woof_front_toggle").click();
        return false;
      });
    }
  });
  const elements = [];
  elements.push(document.querySelector(".woof_container_inner_toimiala"));
  elements.push(document.querySelector(".woof_container_inner_kesto"));
  elements.forEach(function (el) {
    if (!el) return;
    setupAccessibility(el);
  });
});

const setupAccessibility = (el) => {
  const toggleEl = el.querySelector(".woof_front_toggle");
  const toggleHeading = el.querySelector("h4");
  const toggleContainer = el.querySelector(".woof_closed_block");
  if (!toggleEl || !toggleContainer) return;
  const uniqueId = btoa(Math.random());
  toggleContainer.setAttribute("id", uniqueId);
  toggleEl.setAttribute("aria-controls", uniqueId);
  toggleEl.setAttribute("aria-expanded", "false");
  toggleHeading.setAttribute("tabindex", "0");
  toggleEl.addEventListener("click", function (ev) {
    const toggleEl = ev.target;
    if (!toggleEl) return;
    toggleEl.setAttribute(
      "aria-expanded",
      toggleEl.getAttribute("aria-expanded") === "false"
    );
  });
  toggleHeading.addEventListener("keydown", function (ev) {
    const toggleEl = ev.target;
    if (!toggleEl) return;
    if (ev.key === "Enter" || ev.key === " ") {
      toggleEl.click();
    }
  });
};
